import {connect} from 'react-redux';
import {get} from 'lodash';
import {isNil} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {BBBActivationEndDate, BBBBannerEndDate} from '/enum/dates.enum';
import {
  getAcceleratorBonusBanner,
  getClientSupportBonusPlusBanner,
  getIncentiveTripBonusBanner,
} from '/redux/action/coach.action';
import {
  acceleratorBannerCurrentDate,
  acceleratorBannerEndDate,
  activationDateById,
  CSBPlusBannerEndDate,
  hasBusinessBuilderBonusBanner,
  incentiveTripBannerEndDate,
  incentiveTripBannerFQV,
  incentiveTripBannerNewCoachCount,
  incentiveTripBannerOE,
  incentiveTripBannerPath,
  incentiveTripBannerRankAchievements,
  incentiveTripBannerStartDate,
  incentiveTripBannerSupportPathCount,
  incentiveTripBonusBanner,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {
  variablesBonusDisplayDate,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {generateCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {withProps} from '/util/selector.util';

import {shouldShowCABBanner} from './AcceleratorBanner/CoachAcceleratorBonusBanner.util';
import {checkFulfillment} from './IncentiveTripBanner/IncentiveTripBanner.util';
import {BonusBannerCards} from './BonusBannerCards';

const withCurrentUserCoachId = withProps({coachId: userId});

export default connect(
  createStructuredSelector({
    coachId: userId,
    acceleratorEndDate: withCurrentUserCoachId(acceleratorBannerEndDate),
    acceleratorCurrentDate: withCurrentUserCoachId(
      acceleratorBannerCurrentDate,
    ),
    CSBPlusEndDate: withCurrentUserCoachId(CSBPlusBannerEndDate),
    incentiveTripStartDate: withCurrentUserCoachId(
      incentiveTripBannerStartDate,
    ),
    incentiveTripEndDate: withCurrentUserCoachId(incentiveTripBannerEndDate),
    incentiveTripBonusBanner: incentiveTripBonusBanner,
    featureFlag: variablesFeatureFlag,
    path: withCurrentUserCoachId(incentiveTripBannerPath),
    orderingEntities: withCurrentUserCoachId(incentiveTripBannerOE),
    rankAchievements: withCurrentUserCoachId(
      incentiveTripBannerRankAchievements,
    ),
    fqv: withCurrentUserCoachId(incentiveTripBannerFQV),
    newCoachCount: withCurrentUserCoachId(incentiveTripBannerNewCoachCount),
    supportPathCount: withCurrentUserCoachId(
      incentiveTripBannerSupportPathCount,
    ),
    hasBusinessBuilderBonusBanner: withCurrentUserCoachId(
      hasBusinessBuilderBonusBanner,
    ),
    coachActivationDate: withCurrentUserCoachId(activationDateById),
    bonusDisplayDate: variablesBonusDisplayDate,
  }),
  dispatch => ({
    getAcceleratorBonusBanner: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getAcceleratorBonusBanner(),
    }),
    getCSBPlusBanner: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getClientSupportBonusPlusBanner(),
    }),
    getIncentiveTripBanner: generateCallback({
      func: dispatch,
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      params: getIncentiveTripBonusBanner(),
    }),
  }),
  (stateProps, dispatchProps, ownProps) => {
    const {
      acceleratorEndDate,
      CSBPlusEndDate,
      incentiveTripStartDate,
      featureFlag,
      path,
      rankAchievements,
      orderingEntities,
      fqv,
      newCoachCount,
      supportPathCount,
      coachActivationDate,
      bonusDisplayDate,
    } = stateProps;

    let remoteConfigBBBActivationEndDate,
      remoteConfigCSBPlusBannerEndDate,
      remoteConfigBBBBannerEndDate;

    try {
      if (bonusDisplayDate) {
        const parsed =
          typeof bonusDisplayDate === 'string'
            ? JSON.parse(bonusDisplayDate)
            : bonusDisplayDate;
        ({
          BBBActivationEndDate: remoteConfigBBBActivationEndDate,
          CSBPlusBannerEndDate: remoteConfigCSBPlusBannerEndDate,
          BBBBannerEndDate: remoteConfigBBBBannerEndDate,
        } = parsed);
      }
    } catch (error) {
      // If parsing fails or bonusDisplayDate is undefined, use defaults
      // console.warn('Failed to parse bonusDisplayDate:', error);
    }

    const coachEligibleActivationEndDate =
      remoteConfigBBBActivationEndDate || BBBActivationEndDate;

    const CSBPBannerEndDate =
      remoteConfigCSBPlusBannerEndDate || CSBPlusEndDate;

    const BBBEndDate = remoteConfigBBBBannerEndDate || BBBBannerEndDate;

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasAcceleratorBonusData: !isNil(acceleratorEndDate),
      hasCSBPlusData: !isNil(CSBPlusEndDate),
      hasIncentiveTripData: !isNil(incentiveTripStartDate),
      showAccelerator: shouldShowCABBanner(
        acceleratorEndDate,
        stateProps.acceleratorCurrentDate,
      ),
      showCSBPlus:
        !isNil(CSBPlusEndDate) &&
        getDateUtilDefaultInstance().isDateSameOrBefore(CSBPBannerEndDate),
      showIncentiveTrip:
        get(featureFlag, 'showIncentiveTrip', false) &&
        !isNil(incentiveTripStartDate),
      isQualified: checkFulfillment({
        path,
        rankAchievements,
        orderingEntities,
        fqv,
        newCoachCount,
        supportPathCount,
        showIncentiveUpdate: get(featureFlag, 'showIncentiveUpdate', false),
      }),
      showBusinessBuilderBonusBanner:
        getDateUtilDefaultInstance().isDateEqualOrBefore(
          coachActivationDate,
          coachEligibleActivationEndDate,
        ) &&
        get(featureFlag, 'showBusinessBuilderBonusBanner', false) &&
        getDateUtilDefaultInstance().isDateSameOrBefore(BBBEndDate),
    };
  },
)(BonusBannerCards);
